import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const eocTeamAlertListRoute: InvariantJiraRoute = {
	name: 'eoc-team-alerts',
	path: '/jira/ops/teams/:teamId/alerts',
	exact: true,
};
